import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';

export const CONTACT_EMAIL = 'kdmaticom@gmail.com';
export default function Contact({ lang = 'en' }) {
  const fr = lang === 'fr';
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject || 'Cursivefont')}&body=${encodeURIComponent(message)}`;
  return <div className="content-narrow py-12 prose-site" data-testid={`contact-page-${lang}`}>
    <h1>{fr ? 'Contacter Cursivefont' : 'Contact Cursivefont'}</h1>
    <p>{fr ? 'Une question, un problème de caractères ou une suggestion ? Écrivez-nous par e-mail.' : 'Have a question, a character display issue or a suggestion? Contact us by email.'}</p>
    <p><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
    <div className="editorial-card p-6 space-y-4">
      <div><Label htmlFor="subject">{fr ? 'Sujet' : 'Subject'}</Label><Input id="subject" value={subject} onChange={e => setSubject(e.target.value)} /></div>
      <div><Label htmlFor="message">Message</Label><Textarea id="message" rows={6} value={message} onChange={e => setMessage(e.target.value)} /></div>
      <a href={href} className="btn-gold inline-flex items-center gap-2 !text-white !no-underline"><Mail className="w-4 h-4" />{fr ? 'Ouvrir mon application e-mail' : 'Open my email app'}</a>
      <p className="text-sm">{fr ? 'Ce bouton prépare un brouillon dans votre messagerie. Vérifiez-le et envoyez-le depuis celle-ci. Le site ne transmet ni ne stocke ce message. Si aucune application ne s’ouvre, copiez l’adresse ci-dessus.' : 'This opens a draft in your email app. Review it and send it from there. The site does not transmit or store this message. If no app opens, copy the email address above.'}</p>
    </div>
  </div>;
}
